export default "__VITE_ASSET__DslmSj90__"